import React, { useEffect, useState } from "react";
import "./App.css";
import { RetellWebClient } from "retell-client-js-sdk";
import axios from "axios";

const agentId = "agent_75f8410d4da194e4404c347ab8";

interface RegisterCallResponse {
  access_token: string;
}

const retellWebClient = new RetellWebClient();

const App = () => {
  const [isCalling, setIsCalling] = useState(false);

  // Initialize the SDK
  useEffect(() => {
    retellWebClient.on("call_started", () => {
      console.log("call started");
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setIsCalling(false);
    });

    // When agent starts talking for the utterance
    // useful for animation
    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });

    // When agent is done talking for the utterance
    // useful for animation
    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });

    // Real time pcm audio bytes being played back, in format of Float32Array
    // only available when emitRawAudioSamples is true
    retellWebClient.on("audio", (audio) => {
      // console.log(audio);
    });

    // Update message such as transcript
    // You can get transcrit with update.transcript
    // Please note that transcript only contains last 5 sentences to avoid the payload being too large
    retellWebClient.on("update", (update) => {
      // console.log(update);
    });

    retellWebClient.on("metadata", (metadata) => {
      // console.log(metadata);
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      // Stop the call
      retellWebClient.stopCall();
    });
  }, []);

  const toggleConversation = async () => {
    if (isCalling) {
      retellWebClient.stopCall();
    } else {
      const registerCallResponse = await registerCall(agentId);
      if (registerCallResponse.access_token) {
        retellWebClient
          .startCall({
            accessToken: registerCallResponse.access_token,
          })
          .catch(console.error);
        setIsCalling(true); // Update button to "Stop" when conversation starts
      }
    }
  };

  async function registerCall(agentId: string): Promise<RegisterCallResponse> {
    const payload = { agent_id: agentId };

    const response = await axios.post(
      "https://api.retellai.com/v2/create-web-call",
      payload,
      {
        headers: {
          Authorization: "Bearer key_20709011a05c36d84649c60fa2e9", // Replace with your actual Bearer token
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;

    // try {
    //   // Update the URL to match the new backend endpoint you created
    //   const response = await fetch("http://localhost:8080/create-web-call", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       agent_id: agentId, // Pass the agentId as agent_id
    //       // You can optionally add metadata and retell_llm_dynamic_variables here if needed
    //       // metadata: { your_key: "your_value" },
    //       // retell_llm_dynamic_variables: { variable_key: "variable_value" }
    //     }),
    //   });

    //   if (!response.ok) {
    //     throw new Error(`Error: ${response.status}`);
    //   }

    //   const data: RegisterCallResponse = await response.json();
    //   return data;
    // } catch (err) {
    //   console.log(err);
    //   throw new Error(err);
    // }
  }

  return (
    <div className="App">
      <header className="App-header">
        <img
          src="avatar.png"
          alt="profile"
          className="h-64 w-64 rounded-full mx-auto mb-4"
        />
        <h1 className="text-2xl font-bold text-center mb-2">Hi, I am Besty!</h1>
        <p className="text-center mb-4">Click the button below to start talking to me.</p>
        <button
          className="call-button px-12 py-4 text-white font-bold rounded transition duration-200 text-3xl mt-6"
          style={{ backgroundColor: "#de1738" }}
          onClick={toggleConversation}
        >
          {isCalling ? "Stop" : "Talk"}
        </button>
      </header>
    </div>
  );
};

export default App;
